import React, { useContext, useState } from 'react';
import Footer from '../../../layout/Footer/Footer';
import Popovers from '../../../components/bootstrap/Popovers';
import useDarkMode from '../../../hooks/useDarkMode';
import classNames from 'classnames';
import ConfigContext from '../../../contexts/configContext';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();
	const [footerWidth, setFooterWidth] = useState<Number>();
	const resizeQuery = () => {
		setFooterWidth(window.innerWidth);
	};
	window.addEventListener('resize', resizeQuery);
	const getYear = () => {
		return new Date().getFullYear();
	};
	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<span className='fw-light'>
							© {getYear()}{' '}
							<a
								href='https://arktechltd.com'
								target={'_blank'}
								style={{ textDecoration: 'none' }}>
								{process.env.REACT_APP_COMPANY_NAME}
							</a>
						</span>
					</div>
					<div className='col-auto'>
						<a
							style={{ cursor: 'pointer' }}
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>{process.env.REACT_APP_COMPANY_NAME}</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
